import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        children: [
            {
                path: 'login',
                loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
            }
        ]
    },
    {
        path: 'page',
        children: [
            {
                path: 'vendoronboard/:id',
                loadComponent: () => import('./page/customer-onboard/customer-onboard.component').then(m => m.CustomerOnboardComponent)
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
